import React from 'react';
import FlightCourse from "../FlightCourse/FlightCourse";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Draggable from "../../../Common/Draggable/Draggable";
import {switchCoursesIndexes} from "../../../../services/flightCourse/actions";
import {debounce} from "lodash";
import styles from '../../SearchWidget.module.scss';
import refs from './MultiCity/legs-react-refs';
import responsiveDefinitions from "../../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";
import {DUPLICATED_CITY_PAIR_ERROR_KEY, DATES_OVERLAPPING_ERROR_KEY} from "../../../../services/flightCourse/errors-controller";
import Errors from "./Errors";
import {withTranslation} from "react-i18next";

const FlightLegs = ({legs, multiCityMode, switchCoursesIndexes, courseElementsRefs, imagineMode, userCardType, Styles, t}) => {

    const isDesktop = Styles.matches(false, false, false);
    const legsCount = multiCityMode ? legs.length : 1;
    const errors = [];

    const legsJsx = legs.slice(0, legsCount).map((leg, idx) => {
        if (leg.errors.some(e => e.type === DUPLICATED_CITY_PAIR_ERROR_KEY)) errors.push(DUPLICATED_CITY_PAIR_ERROR_KEY);
        if (leg.errors.some(e => e.type === DATES_OVERLAPPING_ERROR_KEY)) errors.push(DATES_OVERLAPPING_ERROR_KEY);

        return (
            <Draggable
                key={idx}
                index={idx}
                id={idx}
                moveCard={debounce(switchCoursesIndexes, 200)}
                style={{position: 'relative'}}
                active={!!idx && legsCount > 2 && isDesktop}>
                <FlightCourse
                    course={{...leg, idx}}
                    originRef={refs[idx][0]}
                    destinationRef={refs[idx][1]}
                    datesRef={refs[idx][2]}
                    removeCourseBtnRef={refs[idx][3]}
                    addCourseBtnRef={refs[idx][4]}
                    prevRef={idx ? refs[idx-1][2] : refs[0][0]}
                    nextRef={idx < 7 ? refs[idx+1][0] : refs[0][0]}
                    isFirstCourse={!idx}
                    isLastCourse={idx === legs.length - 1}
                    multiCityMode={multiCityMode}
                    imagineMode={imagineMode}
                    imagineCardType={userCardType}
                    legsCount={legsCount}
                />
            </Draggable>
        )
    });

    let errorsText = '';
    if (errors.length) {
        if (errors.includes(DUPLICATED_CITY_PAIR_ERROR_KEY)) errorsText += t('City pair duplication');
        if (errors.includes(DATES_OVERLAPPING_ERROR_KEY)) errorsText +=
            (errorsText ? ` ${t('and')} ` + t('inconsistent date sequence') : t('Inconsistent date sequence'));
        if (errorsText) errorsText += '.';
    }

    return (
        <div className={styles.flightLegsContainer}>
            {legsJsx}
            <Errors show={!!errors.length}><i className="fa fa-exclamation-triangle" aria-hidden="true"/>&nbsp;{errorsText}</Errors>
        </div>
    );

};

FlightLegs.propTypes = {
    multiCityMode: PropTypes.bool,
    imagineMode: PropTypes.bool,
    userCardType: PropTypes.string,
    switchCoursesIndexes: PropTypes.func,
    legs: PropTypes.array,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    courseElementsRefs: PropTypes.array,
    t: PropTypes.func,
};

FlightLegs.defaultProps = {
    multiCityMode: false,
    imagineMode: false,
    userCardType: '',
    switchCoursesIndexes: () => null,
    legs: [],
    prevRef: null,
    nextRef: null,
    courseElementsRefs: refs,
    t: s => s,
};

export default connect(
    state => ({
        legs: state.flightCourse.legs,
        multiCityMode: state.flightCourse.roundTrip === 'MULTI',
        imagineMode: state.flightCourse.imagineMode,
        userCardType: state.common.userCardType
    }),
    {switchCoursesIndexes})(responsiveDefinitions(withTranslation()(FlightLegs)));
